export {};
//# sourceMappingURL=Ellipsis.types.js.map